/**
 * API Base URL utility
 * Returns the correct API path based on whether we're on staging or production
 */

// Check if we're on staging environment
const isStaging = typeof window !== 'undefined' && window.location.pathname.startsWith('/staging');

// API base path
export const API_BASE = isStaging ? '/staging/api' : '/api';

/**
 * Get the full API URL for a given endpoint
 * @param {string} endpoint - The API endpoint (e.g., '/me', '/jobs/123')
 * @returns {string} The full API URL
 */
export function apiUrl(endpoint) {
  // Ensure endpoint starts with /
  const path = endpoint.startsWith('/') ? endpoint : `/${endpoint}`;
  return `${API_BASE}${path}`;
}

export default API_BASE;
